$('#make_input').on('focus', function () {
    $(this).parent().find(".chosen-single .js-title").trigger("click");
    //console.log('Focus #make_input');
}).on('blur', function () {
});
$('#model_input').on('focus', function () {
    $(this).parent().find(".chosen-single .js-title").trigger("click");
    //console.log('Focus #make_input');
}).on('blur', function () {
});
$('#year_input').on('focus', function () {
    $(this).parent().find(".chosen-single .js-title").trigger("click");
    //console.log('Focus #make_input');
}).on('blur', function () {
});

const $el1 = $('[data-field-index="1"][data-value]');
const $el2 = $('[data-field-index="2"][data-value]');
const $el3 = $('[data-field-index="3"][data-value]');

let changingField = 0; // 0 - ничего, 1 - меняем 1-й, 2 - меняем 2-й

function resetField($el) {
    if (!$el.length) return;
    //$el.attr('data-value', '');
    $el.find("> input[name='search']").val('');
    $el.next().find('.js-title').trigger("click");
}

function observeField($el, focusSelector, resetFields = []) {
    if (!$el.length) return;

    let lastValue = $el.attr('data-value'); // сохраняем текущее значение

    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-value') {
                const newValue = $el.attr('data-value');
                if (newValue === lastValue) return; // если значение не изменилось — ничего не делаем
                lastValue = newValue;

                if (newValue === null || newValue === '') {
                    // Если очистили значение — можно тоже делать сброс
                    resetFields.forEach(resetField);
                    return;
                }

                if (focusSelector === '#model_input') changingField = 1;
                else if (focusSelector === '#year_input') changingField = 2;

                $el.find("> input[name='search']").val(newValue);
                $el.next().find('.js-title').trigger("click");

                resetFields.forEach(resetField);

                setTimeout(() => {
                    if ((changingField === 1 && focusSelector === '#model_input') ||
                        (changingField === 2 && focusSelector === '#year_input')) {
                        document.querySelector(focusSelector).focus();
                        changingField = 0;
                    }
                }, 100);
            }
        });
    });

    observer.observe($el[0], { attributes: true, attributeFilter: ['data-value'] });
}

// 1-й input: при изменении сбрасываем 2-й и 3-й, фокус на 2-й
observeField($el1, '#model_input', [$el2, $el3]);
// 2-й input: при изменении сбрасываем 3-й, фокус на 3-й
observeField($el2, '#year_input', [$el3]);
// 3-й input: просто обновляем значение без фокуса и сбросов
if ($el3.length) {
    let lastValue3 = $el3.attr('data-value');
    const observer3 = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-value') {
                const newValue = $el3.attr('data-value');
                if (newValue === lastValue3) return;
                lastValue3 = newValue;

                $el3.find("> input[name='search']").val(newValue);
                $el3.next().find('.js-title').trigger("click");
            }
        });
    });
    observer3.observe($el3[0], { attributes: true, attributeFilter: ['data-value'] });
}


$(document).on("click", ".js-btn-reset", function (e){
    setTimeout(function (){
        $("#make_input").val("");
        $("#model_input").val("");
        $("#year_input").val("");
        $(".chosen-drop").removeClass("active");
    }, 100);
});

// Функция для инициализации input значением из data-value, если оно есть и не пустое
function initInputValue($el) {
    if (!$el.length) return;
    const val = $el.attr('data-value');
    if (val && val !== '') {
        $el.find("> input[name='search']").val(val);
    }
}

// Инициализация всех полей при загрузке
initInputValue($el1);
initInputValue($el2);
initInputValue($el3);

setTimeout(function (){
    $("#helper_click__empty").trigger("click");
}, 600);


window.addEventListener('load', () => {
    if (document.activeElement && document.activeElement.blur) {
        document.activeElement.blur();
    }
});


/*<script>
    const inputEvent = new Event('input', { bubbles: true, cancelable: true });

    // 1st step Make
    const hideLiWhenReady = setInterval(() => {
    const listItems = document.querySelectorAll('[data-field-index="1"] ul.chosen-results li');
    if (listItems.length > 0) {
    listItems.forEach(li => {
    li.style.display = 'none';
});
    clearInterval(hideLiWhenReady);
}
}, 100);

    // 2nd step Model
    const hideLiWhenReady2 = setInterval(() => {
    const listItems = document.querySelectorAll('[data-field-index="2"] ul.chosen-results li');
    if (listItems.length > 0) {
    listItems.forEach(li => {
    li.style.display = 'none';
});
    clearInterval(hideLiWhenReady2);
}
}, 100);

    // 3d step Year
    const hideLiWhenReady3 = setInterval(() => {
    const listItems = document.querySelectorAll('[data-field-index="3"] ul.chosen-results li');
    if (listItems.length > 0) {
    listItems.forEach(li => {
    li.style.display = 'none';
});
    clearInterval(hideLiWhenReady3);
}
}, 100);


    document.addEventListener('DOMContentLoaded', function () {

    const input = document.querySelector('[data-field-index="1"] .chosen-search input');
    const input2 = document.querySelector('[data-field-index="2"] .chosen-search input');
    const input3 = document.querySelector('[data-field-index="3"] .chosen-search input');

    let NS = {
    input: function (){
    if (input) {
    input.addEventListener('input', function (e) {
    const value = e.target.value;
    const li = document.querySelectorAll('[data-field-index="1"] ul.chosen-results li');
    if(value){
    console.log('Not Empty:', value);
}else{
    input2.value = "";
    input3.value = "";
    input2.dispatchEvent(inputEvent);
    input3.dispatchEvent(inputEvent);
    console.log('Empty');
    setTimeout(function (){
    console.log(li.length);
    for (let i = 0; i < li.length; i++) {
    li[i].style.display = 'none';
}
}, 300);
}
});
}
},
    input2: function (){
    if (input2) {
    input2.addEventListener('input', function (e) {
    const value2 = e.target.value;
    const li2 = document.querySelectorAll('[data-field-index="2"] ul.chosen-results li');
    if(value2){
    console.log('Not Empty:', value2);
}else{
    console.log('Empty');
    setTimeout(function (){
    console.log(li2.length);
    for (let i = 0; i < li2.length; i++) {
    li2[i].style.display = 'none';
}
}, 300);
}
});
}
},
    input3: function (){
    if (input3) {
    input3.addEventListener('input', function (e) {
    const value3 = e.target.value;
    const li3 = document.querySelectorAll('[data-field-index="3"] ul.chosen-results li');
    if(value3){
    console.log('Not Empty:', value3);
}else{
    console.log('Empty');
    setTimeout(function (){
    console.log(li3.length);
    for (let i = 0; i < li3.length; i++) {
    li3[i].style.display = 'none';
}
}, 300);
}
});
}
},
    _init: function (){
    this.input();
    this.input2();
    this.input3();
}
}
    NS._init();
});

</script>*/